<template>
  <el-dialog
    title="添加标签"
    :visible.sync="visible"
    @closed="closed"
    @open="open"
    custom-class="property-dialog"
  >
    <el-form ref="form" :model="form" :rules="rules">
      <el-form-item label="标签名称：" prop="tagList">
        <el-checkbox-group v-model="form.tagList" >
          <el-checkbox
            v-for="tag in tagOptions"
            :label="tag.id"
            :key="tag.id"
            :disabled="tagValue.includes(tag.id)"
          >{{tag.name}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button type="primary" @click="submit" :loading="loading">提交</el-button>
      <el-button @click="visible = false">取消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import http from '@/plugins/axios'
import * as utils from '@/utils'

export default {
  props: ['value'],
  data() {
    return {
      rules: {
        tagList: { required: true, message: '请选择标签名称' }
      },
      visible: false,
      form: {},
      loading: false,
      propValue: [],
      tagOptions: [],
      tagValue: []
    }
  },
  methods: {
    closed() {
      this.$emit('input', undefined)
      // this.form = {}
    },
    open() {
      // 获取字段选项
      http.post('/allmessage/getchoice', { type: 'project' }).then(res => {
        this.tagOptions = res.data.data.find(x => x.propertycname === this.value.name).list
      })
    },
    submit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.loading = true
          http.post('allmessage/addrelatej', {
            id: this.$route.query.id,
            type: 'project',
            relate: this.form.tagList.join(',')
          }).then(res => {
            if (res.data.status && res.data.status === 'success') {
              this.$parent.reload('property')
              this.loading = false
              this.visible = false
            }
          })
        }
      })
    }
  },
  watch: {
    value(val) {
      if (val !== undefined) {
        this.visible = true
        this.form = { tagList: [] }
        if (val.tagList.length > 0) {
          let tagList = utils.cloneDeep(val.tagList)
          this.tagValue = tagList.map(tag => tag.propertyid)
        }
      }
    }
  }
}
</script>

<style lang="scss">
.property-dialog {
  .el-dialog__footer {
    text-align: center;
  }
}
</style>
